/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { Form, Input, Typography } from "antd";
import { ShareDesignDetails } from "interfaces/ShareDesign/IShareDesign";

const { Title } = Typography;

interface AdditionalInformationProps {
  onHandleBillingForm: (event: any) => void;
  billingInformation: ShareDesignDetails;
}

const AdditionalInformation: React.FC<AdditionalInformationProps> = ({
  onHandleBillingForm,
  billingInformation,
}: AdditionalInformationProps) => {
  const isEmail = (email: string) => {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (email && !regex.test(email)) {
      return "error";
    }
    return "";
  };
  return (
    <div className="billing-information mt-3">
      <Title level={4} className="section-heading">
        Additional Information
      </Title>
      <Form.Item
        label="Confirmation Email Address"
        name="confirmationEmailAddress"
        className="input-label"
        data-test-selector={"lblConfirmationEmailAddress"}
      >
        <Input
          className="form-input"
          data-test-selector={"txtConfirmationEmailAddress"}
          name="confirmationEmailAddress"
          onChange={onHandleBillingForm}
          status={isEmail(billingInformation?.confirmationEmailAddress)}
        />
        {isEmail(billingInformation?.confirmationEmailAddress) ? (
          <span style={{ float: "left", color: "red", fontWeight: "600", fontSize: "12px" }}>
            Invalid Email
          </span>
        ) : null}
      </Form.Item>
      <Form.Item label="Notes" name="notes" className="input-label" data-test-selector={"lblNotes"}>
        <Input.TextArea
          name="notes"
          className="form-input"
          data-test-selector={"txtNotes"}
          onChange={onHandleBillingForm}
        />
      </Form.Item>
    </div>
  );
};

export default AdditionalInformation;
